import React from "react";
import {updateStore} from "./update.store";
import {linksStore} from "./links.store";
import {componentStore} from "./component.store";
import {settingDownloadStore} from "./setting.download.store";

const storesContext = React.createContext({
    updateStore,
    linksStore,
    settingDownloadStore,
    componentStore,
});

export const useStores = () => React.useContext(storesContext);